import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getWorkOrOfficeLocationList = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.WORK_OR_OFFICE_LOCATION_LIST
  );
};

export default getWorkOrOfficeLocationList;
